<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <div class="section-one part-header">
      <div class="nav-bar nav-bar-black">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span>联系我们
        </div>
        <!-- <img src="../../img/contact/nav-top.png" class="product contact" /> -->
      </div>

      <div class="sub-title">
        <img src="../../img/contact/sub-title2.png" />
      </div>

      <div class="content">
        <div class="left">
          <h3>班尼戈（中国）管路系统</h3>
          <p>地址: 浙江省宁波市鄞州区泰康中路558号商会国贸中心A座39楼</p>
          <p>物流中心:浙江省嘉兴市海盐县经济开发区棕桐路555号[班尼戈产业园]</p>
          <p>服务电话:4001085686</p>
          <p>邮箱:nbibp@ibpchina.com</p>
          <p>德国官网:<a href="http://www.conexbanninger.com">http://www.conexbanninger.com</a></p>
          
          <div class="english">
            Address: 39F Building A, International Trade Center, No.558 Taikang Middle Road,<br/>
            Yinzhou District, Ningbo City, Zhejiang Province<br/>
            Logistics Center: No.555 Palm Tong Road, Haiyan Economic Development Zone,<br/>
            Jiaxing City, Zhejiang Province [Bänninger Industrial Park]<br/>
            Service telephone :4001085686<br/>
            Email: nbibp@ibpchina.com<br/>
            Germany's official website: <a href="http://www.conexbanninger.com">http://www.conexbanninger.com</a>
          </div>
        </div>
        <div class="right">
          <div class="map">
            <img src="../../img/contact/map-1.png">
            <!-- <p>11</p> -->
            <a href="https://j.map.baidu.com/ab/4XF" target="_blank" class="btn">导航至总部 ></a>
          </div>
          <div class="map map2">
            <img src="../../img/contact/map-2.png">
            <!-- <p>11</p> -->
            <a href="https://j.map.baidu.com/0e/yWZh" target="_blank" class="btn">导航至物流中心 ></a>
          </div>
        </div>
      </div>
      <!-- <div class="pic">
        <img src="../../img/contact/bg-pic.png" class="" />
      </div> -->
    </div>

    <Footer />

  </div>

</template>

<script>
// idmport $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  }
};
</script>

<style scoped lang="less">
.part-header {
  background-color: #EFEFEF;
  height: 950px;
  .sub-title {
    width: 1100px;
    position: absolute;
    left: 0;
    right: 0;
    top: 200px;
    margin: 0 auto;
    // margin: 300px auto 60px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .pic {
    position: absolute;
    left: 0;
    right: 0;
    top: 200px;
    // bottom: 130px;
    width: 1100px;
    // height: 508px;
    margin: 0 auto;
    img {
        width: 100%;
        height: 100%;
    }
  }
  .content {
    position: absolute;
    left: 0;
    right: 0;
    top: 315px;
    width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 520px;
      font-size: 14px;
      color: #333333;
      h3 {
        font-size: 20px;
        margin-bottom: 45px;
      }
      p {
        line-height: 24px;
        font-size: 16px;
      }
      .english {
        margin-top: 30px;
      }
      a {
        color: #333333;
      }
      a:hover {
        text-decoration: underline;
      }
    }
    .right {
      // background-color: red;
      width: 540px;
      display: flex;
      justify-content: space-between;
      // justify-content: space-around;
      align-items: center;
      .map {
        // background: yellow;
        width: 269px;
        text-align: center;
        &.map2 {
          width: 253px;
        }
        img {
          width: auto;
          height: 249px;
          margin-bottom: 35px;
        }
        .btn {
          display: inline-block;
          width: 133px;
          height: 24px;
          line-height: 24px;
          background-color: #003D7F;
          text-align: center;
          color: #FFF;
          font-weight: bold;
          font-size: 14px;
          border-radius: 50px;
        }
      }
    }
  }
}
</style>